export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '77d0cfe4-958d-4bfb-bbc6-c92f7263dcc1';
export const MODAL_CLOSE_SEC = 0.5;
